/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import type { RefObject } from 'react';

interface MarkdownFigureProps {
    className?: string;
    content: string;
    containerRef?: RefObject<HTMLDivElement | null>;
    fillParent?: boolean;
}

function MarkdownFigure({ className, content, containerRef, fillParent = false }: MarkdownFigureProps) {
    return (
        <div ref={containerRef} className={`markdown-surface content-surface${fillParent ? ' markdown-surface--fill' : ''}${className ? ` ${className}` : ''}`}>
            <ReactMarkdown remarkPlugins={[remarkGfm]}>
                {content}
            </ReactMarkdown>
        </div>
    );
}

export default MarkdownFigure;
